const regionMap: Record<string, string> = {
  // EMEA (Europe, Middle East, Africa)
  DE: 'EMEA',
  FR: 'EMEA',
  GB: 'EMEA',
  IT: 'EMEA',
  ES: 'EMEA',
  NL: 'EMEA',
  CH: 'EMEA',
  AT: 'EMEA',
  BE: 'EMEA',
  DK: 'EMEA',
  FI: 'EMEA',
  IE: 'EMEA',
  NO: 'EMEA',
  SE: 'EMEA',
  PL: 'EMEA',
  CZ: 'EMEA',
  HU: 'EMEA',
  RO: 'EMEA',
  BG: 'EMEA',
  HR: 'EMEA',
  SI: 'EMEA',
  SK: 'EMEA',
  LT: 'EMEA',
  LV: 'EMEA',
  EE: 'EMEA',
  GR: 'EMEA',
  PT: 'EMEA',
  CY: 'EMEA',
  MT: 'EMEA',
  LU: 'EMEA',
  IS: 'EMEA',
  TR: 'EMEA',
  IL: 'EMEA',
  SA: 'EMEA',
  AE: 'EMEA',
  ZA: 'EMEA',
  EG: 'EMEA',
  MA: 'EMEA',
  NG: 'EMEA',
  KE: 'EMEA',
  GH: 'EMEA',

  // Americas
  US: 'Americas',
  CA: 'Americas',
  MX: 'Americas',
  BR: 'Americas',
  AR: 'Americas',
  CL: 'Americas',
  CO: 'Americas',
  PE: 'Americas',
  VE: 'Americas',
  EC: 'Americas',
  UY: 'Americas',
  PY: 'Americas',
  BO: 'Americas',
  CR: 'Americas',
  PA: 'Americas',
  GT: 'Americas',
  HN: 'Americas',
  SV: 'Americas',
  NI: 'Americas',
  DO: 'Americas',
  CU: 'Americas',
  JM: 'Americas',
  TT: 'Americas',

  // APAC (Asia-Pacific)
  JP: 'APAC',
  CN: 'APAC',
  KR: 'APAC',
  IN: 'APAC',
  AU: 'APAC',
  NZ: 'APAC',
  SG: 'APAC',
  MY: 'APAC',
  TH: 'APAC',
  VN: 'APAC',
  PH: 'APAC',
  ID: 'APAC',
  HK: 'APAC',
  TW: 'APAC',
  MO: 'APAC',
  BN: 'APAC',
  KH: 'APAC',
  LA: 'APAC',
  MM: 'APAC',
  BD: 'APAC',
  LK: 'APAC',
  NP: 'APAC',
  BT: 'APAC',
  MV: 'APAC',
  PK: 'APAC',
  AF: 'APAC',
  MN: 'APAC',
  KZ: 'APAC',
  UZ: 'APAC',
  KG: 'APAC',
  TJ: 'APAC',
  TM: 'APAC',
  FJ: 'APAC',
  PG: 'APAC',
  SB: 'APAC',
  VU: 'APAC',
  NC: 'APAC',
  PF: 'APAC',
  WS: 'APAC',
  TO: 'APAC',
  TV: 'APAC',
  NR: 'APAC',
  KI: 'APAC',
  MH: 'APAC',
  FM: 'APAC',
  PW: 'APAC',
};

export const getRegionFromCountries = (countries: string[]): string => {
  if (!countries || countries.length === 0) return 'Global';

  const regions = [...new Set(countries.map(country => regionMap[country]).filter(Boolean))];

  if (regions.length === 0) return 'Global';
  if (regions.length === 1) return `Global - ${regions[0]}`;
  if (regions.length > 1) return 'Global - Multi-Region';

  return 'Global';
};
